import { NgModule } from '@angular/core';

import { PipeFormationComponent } from './pipe-formation.component';
import { StagePipeCardComponent } from './stage-pipe-card/stage-pipe-card.component';
import { StagePipeStageCreationComponent } from './stage-creation/stage-creation.component';
import { BasePipelineModule } from '../pipe-base/pipe-base.module';
import { CursusCreationComponent } from './stage-cursus/cursus-creation/cursus-creation.component';
import { CursusEditComponent } from './stage-cursus/cursus-edit/cursus-edit.component';
import { CursusDeleteComponent } from './stage-cursus/cursus-delete/cursus-delete.component';
import { CursusDuplicateComponent } from './stage-cursus/cursus-duplicate/cursus-duplicate.component';


@NgModule({
  imports: [
    BasePipelineModule,
  ],
  declarations: [
    StagePipeStageCreationComponent,
    StagePipeCardComponent,
    PipeFormationComponent,
    CursusCreationComponent,
    CursusEditComponent,
    CursusDeleteComponent,
    CursusDuplicateComponent,
  ],
  exports: [
    StagePipeStageCreationComponent,
    StagePipeCardComponent,
    PipeFormationComponent,
    CursusCreationComponent,
    CursusEditComponent,
    CursusDeleteComponent,
    CursusDuplicateComponent,
  ]
})

export class FormationPipelineModule { }
